import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var VendorReqListRes;
export const VendorReqListTodo = createAsyncThunk('VendorReqList', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Get",
            url: process.env.REACT_APP_API_URL + `user_help_request/${'0'}`,
            params:{
                'request_type':'vendor'
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return VendorReqListRes = res.data

    } catch (error) {
        return VendorReqListRes = error.response.data
    }
})

const VendorReqListSlice = createSlice({
    name: 'VendorReqList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(VendorReqListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('equipmentList', state.data.response)
        });
        builder.addCase(VendorReqListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default VendorReqListSlice.reducer; 